const moneyFormat = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const dateTimeFormat = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

const dateFormat = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
})

/** 12345.5 -> «12 345,50 ₽». Пустое значение -> «—». */
export const formatMoney = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined || value === '') {
    return '—'
  }
  const number = Number(value)
  return Number.isNaN(number) ? String(value) : `${moneyFormat.format(number)} ₽`
}

export const formatDateTime = (value: string | null | undefined): string => {
  if (!value) {
    return '—'
  }
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? String(value) : dateTimeFormat.format(date)
}

export const formatDate = (value: string | null | undefined): string => {
  if (!value) {
    return '—'
  }
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? String(value) : dateFormat.format(date)
}

/** «12 мин назад», «3 ч назад», «5 дн назад». */
export const formatAgo = (value: string | null | undefined): string => {
  if (!value) {
    return '—'
  }
  const time = new Date(value).getTime()
  if (Number.isNaN(time)) {
    return String(value)
  }
  const minutes = Math.max(0, Math.floor((Date.now() - time) / 60000))
  if (minutes < 1) {
    return 'только что'
  }
  if (minutes < 60) {
    return `${minutes} мин назад`
  }
  const hours = Math.floor(minutes / 60)
  if (hours < 48) {
    return `${hours} ч назад`
  }
  return `${Math.floor(hours / 24)} дн назад`
}
